import { createInertiaApp } from '@inertiajs/react'
import '@styles/application.css'

import { type ComponentType, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import AppLayout from '../components/layouts/AppLayout'
import { ThemeProvider } from '../components/ThemeContext'

type PageModule = {
  default: ComponentType<Record<string, unknown>> & {
    layout?: (page: ReactNode) => ReactNode
  }
}

const standalonePages = [
  'Auth/Login',
  'Invitations/Show',
]

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<PageModule>('../pages/**/*.{jsx,tsx}', { eager: true })
    const page = pages[`../pages/${name}.jsx`] || pages[`../pages/${name}.tsx`]

    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }

    if (!standalonePages.includes(name)) {
      page.default.layout ||= (pageContent: ReactNode) => <AppLayout>{pageContent}</AppLayout>
    }

    return page
  },

  setup({ el, App, props }) {
    createRoot(el).render(
      <ThemeProvider>
        <App {...props} />
      </ThemeProvider>
    )
  },

  // Cancel the progress bar; on a single-box dev server it just causes a
  // perceived flash on every navigation (visit completes faster than the
  // 250 ms delay, but the bar still flickers on slower paints).
  progress: false,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
    },
  },
})
